// extracted by mini-css-extract-plugin
export var chip = "_53-9";
export var chipLabel = "_53-a";
export var close = "_53-7";
export var closeIcon = "_53-8";
export var error = "_53-6";
export var infoTooltip = "_53-2";
export var innerContainer = "_53-1";
export var input = "_53-b";
export var medium = "_53-5";
export var outerContainer = "_53-0";
export var small = "_53-4";
export var xSmall = "_53-3";